import { TodoListId, TodoListIdType } from 'owa-todo-list-types';

export function getDefaultListId(): TodoListId {
    return {
        type: TodoListIdType.Folder,
        Id: null,
    };
}
